import(/* webpackMode: "eager", webpackExports: ["Banners"] */ "/opt/build/repo/app/_components/layout/navigation/banners/index.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["BlogClient"] */ "/opt/build/repo/app/[locale]/(blog)/blog/[slug]/BlogClient.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/opt/build/repo/components/modules/pdp-footer/index.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/opt/build/repo/components/pages/BlogRedesign/BlogArticlePage/index.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/opt/build/repo/components/pages/BlogRedesign/BlogHeader/index.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/opt/build/repo/node_modules/next-intl/dist/esm/production/navigation/shared/BaseLink.js");
